<template>
    <div style="">
        <div class="text-h4" style="margin-top: 15px;">
            確認完了
        </div>
        <v-divider></v-divider>
        <v-row justify="center" class="mt-4">
            <v-col cols="auto" >
                <v-icon x-large>mdi-email-edit</v-icon>
            </v-col>
            <v-col cols="8" >
                <p class="text-left font-weight-bold">
                    契約の確認処理を受け付けました。
                </p>
                <p class="text-left">
                    合意締結後に、登録されたメールアドレス宛にPDFファイルが届きます。
                </p>
            </v-col>
        </v-row>
        <v-row justify="center" class="my-2" v-if="isRegisterUser">
            <v-btn color="blue" class="white--text" href="/documents/dashboard?count=1">ダッシュボードへ</v-btn>
        </v-row>
        <v-divider></v-divider>
        <!-- <div style="width:100%;max-width:980px;margin:30px auto;border-radius:18px;background:#F4FEFB;padding:20px;box-shadow: 0px 0px 16px -6px rgba(0,0,0,0.6);">
            <v-row justify="center" class="my-2" v-if="!isRegisterUser">
                <v-col class="text-center" cols="auto" >
                    <h1>電子契約サービス「DX-Sign」について</h1>
                </v-col>
          　</v-row>
          　<v-row justify="center" class="mx-md-8">
                <v-col class="text-center" cols="5">
                    <h3 style="margin-bottom:10px;">いま確認した書類を<br><span style="color:#ff0000;font-size:150%;">無料</span>で<span style="color:#ff0000;font-size:150%;">管理</span>。</h3>
                    <v-card-actions class="text-center d-inline-block">
                        <v-img
                            max-height="105"
                            max-width="150"
                            src="/documents/images/icon_pc.png"
                            alt="確認した書類を無料で管理"
                            ></v-img>
                    </v-card-actions>
                    <h4 style="margin:20px auto 30px;font-size:16px;">
                        DX-SignのFreeプラン登録で<br>書類の検索や確認がかんたんに。
                    </h4>
                    <v-card-actions class="text-center d-inline-block" style=";margin-top:30px;">
                        <v-list-item link href="https://www.dx-sign.jp/apply_free/">
                            <v-btn color="orange" class="white--text d-inline-block" style="text-transform: none">Freeプラン(無料)を試してみる</v-btn>
                        </v-list-item>
                    </v-card-actions>
                </v-col>
                <v-spacer></v-spacer>
                <v-col class="text-center" cols="5">
                    <h3 style="margin-bottom:20px;">契約締結までの時間が<br><span style="color:#ff0000;font-size:150%;">1分</span>に短縮。業務効率<span style="color:#ff0000;font-size:150%;">UP</span>!</h3>
                    <v-card-actions class="text-center d-inline-block">
                        <v-img
                            max-height="105"
                            max-width="150"
                            position="center center"
                            src="/documents/images/icon_graph.png"
                            alt="契約業務の無駄を省き能率UP"
                        ></v-img>
                    </v-card-actions>
                    <h4 style="margin:20px auto 30px;font-size:16px;">
                        書類の印刷や押印「不要」<br>郵送のやり取り「不要」
                    </h4>
                    <div style="font-size:14px;font-weight:bold;height:20px;">＼電子契約「DX-Sign」を詳しく知りたい方へ／</div>
                    <v-card-actions class="text-center d-inline-block">
                        <v-list-item link href="https://www.dx-sign.jp/information/document-a10/">
                            <v-btn color="orange" class="white--text d-inline-block">無料で資料請求(かんたん1分)</v-btn>
                        </v-list-item>
                    </v-card-actions>
                </v-col>
            </v-row>
            <v-row justify="center" class="my-2" style="margin-top:30px;">
                <v-col class="text-center" cols="auto" >
                    <a href="https://www.dx-sign.jp/" style="margin-top:50px;color:#000;font-size:14px;text-decoration:none;border-radius:8px;background:#F5F5F5;text-align:center;padding:10px 15px;min-width:150px;display:inline-block;box-shadow: 0px 4px 2px -1px rgba(174,173,173,0.5);">サイトTOPへ戻る</a>
                </v-col>
            </v-row>
        </div> -->
    </div>
</template>

<script>
  export default {
    props: {
        isRegisterUser: Boolean,
    }, 
};
</script>
